import { tenantConfig } from "./tenantsConfig";

export const getMasterTenant = (tenantName) => {
  return tenantName.split('-')[0];
}

// Apply the UI theme based on the tenantName
// The master Tenanat Theme is always applied
// subTenant will always follow master Tenant

export const applyTenantConfig = (tenantName) => {

  // when apply the tenantName, we always apply the masterTenat Path
  const masterTenant = getMasterTenant(tenantName);
  const masterConfig = tenantConfig[masterTenant] || tenantConfig["ripcord"];
  const theme = masterConfig.theme;

  document.documentElement.style.setProperty(
    "--highlight-color",
    theme.highlightColor
  );

  document.documentElement.style.setProperty(
    "--background-color",
    theme.backgroundColor
  );

  return masterConfig;
};